import {useMutation, useQueryClient} from 'react-query';
import {STORAGE_OBJECTS_QUERY_KEY} from '../init/constants';
import {APIClient} from '../backend/ApiClient';
import {FavoriteObjectsDTO} from '../models/dto/FavoriteObjectsDTO';

export const useMarkAsFavorite = () => {
    const queryClient = useQueryClient();
    const apiClient = APIClient();

    const markAsFavoriteApiCall = (favoriteObjectDTO: FavoriteObjectsDTO) => {
        return apiClient.markAsFavorite(
            favoriteObjectDTO.resourceId,
            !favoriteObjectDTO.isFavorite
        );
    };

    const {mutateAsync: editFolderMutation} = useMutation(markAsFavoriteApiCall, {
        onSuccess: () => {
            queryClient.invalidateQueries(STORAGE_OBJECTS_QUERY_KEY);
        }
    });

    const markAsFavorite = (favoriteObjectsDTO: FavoriteObjectsDTO) => {
        return editFolderMutation(favoriteObjectsDTO);
    };

    return {markAsFavorite: markAsFavorite};
};
